export const columnsPersonasReport = (handleShowImage) => [
  {
    fieldName: "index",
    name: "#",
    width: "100px",
    filter: true,
  },
  {
    fieldName: "fullName",
    name: "Nombre Completo",
    width: "200px",
    filter: true,
  },
  {
    fieldName: "identityNumber",
    name: "Número de Identidad",
    width: "180px",
    filter: true,
  },
  {
    fieldName: "phoneNumber",
    name: "Teléfono",
    width: "150px",
    filter: true,
  },
  {
    fieldName: "photoUrl",
    name: "Foto",
    width: "120px",
    noExported: true,
    filter: false,
    body: (item) => {
      return (
        <div className="table-photo">
          {item.photoUrl ? (
            <img
              onClick={() => handleShowImage(item)}
              src={item.photoUrl}
              alt="Perfil"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <span>Sin foto</span>
          )}
        </div>
      );
    },
  },
  {
    fieldName: "block",
    name: "Bloque",
    width: "120px",
    filter: true,
  },
  {
    fieldName: "houseNumber",
    name: "Número de Casa",
    width: "150px",
    filter: true,
  },
  {
    fieldName: "area",
    name: "Área",
    width: "150px",
    filter: true,
  },
];
